import { ElaborationDocumentFilterEntity } from "src/app/document-management/models/elaboration-doc-filter";


export function filterElaborationEntity(metadati: ElaborationDocumentFilterEntity[], tipiEntita: string[]) {
  let out: ElaborationDocumentFilterEntity[] = []
  if (metadati && metadati.length > 0 && tipiEntita && tipiEntita.length > 0) {

    tipiEntita.forEach(tipo => {

      let metadatiFiltered = metadati.filter(entity => entity.tipoEntita && entity.tipoEntita.label_key === tipo);
      if (metadatiFiltered && metadatiFiltered.length > 0) {
        metadatiFiltered.forEach(metadato => {
          out.push(metadato);
        });
      }

    });

  }
  return out;

}

export function filterElaborationEntityClean(metadati: ElaborationDocumentFilterEntity[], tipiEntita: string[]) {
  let out = filterElaborationEntity(metadati, tipiEntita);
  return removeDuplicates(out);
}

export function removeDuplicates(metadati: ElaborationDocumentFilterEntity[]): ElaborationDocumentFilterEntity[] {
  let filtered: ElaborationDocumentFilterEntity[] = [];

  if (metadati && metadati.length > 0) {

    metadati.forEach(element => {
      if (filtered.length === 0) {
        filtered.push(element);
      } else {
        const finded = filtered.filter(entity => entity.valore === element.valore);
        if (!finded || finded.length === 0) {
          filtered.push(element);
        }
      }
    });
  }
  return filtered;
}

export function getMockEntity(valore:string, uri:string , type: string):ElaborationDocumentFilterEntity{
  let out: any;
  out = {
    tipoEntita: {
      label:type
    },
    uri:uri,
    valore:valore
  }
  return out;
}


export function isNumeric(num) {
  return !isNaN(num)
}
